export const GET_APPLICATION_STATUS = 'GET_APPLICATION_STATUS';
export const GET_APPLICATION_STATUS_ERROR = 'GET_APPLICATION_STATUS_ERROR';
export const GET_APPLICATION_STATUS_SUCCESS = 'GET_APPLICATION_STATUS_SUCCESS';
export const GET_DISPATCHER_TRIGGER_ERROR = 'GET_DISPATCHER_TRIGGER_ERROR';
export const GET_PRINTERS_LOADING = 'GET_PRINTERS_LOADING';
export const GET_DISPATCHER_TRIGGER_SUCCESS = 'GET_DISPATCHER_TRIGGER_SUCCESS';
export const GET_SUPPLIERID_SUCCESS = 'GET_SUPPLIERID_SUCCESS';
export const GET_SUPPLIERID_ERROR = 'GET_SUPPLIERID_ERROR';